import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationRU from "./locales/ru/translation.json";
import translationUZ from "./locales/uz/translation.json";
import translationEN from "./locales/en/translation.json";

const resources = {
  ru: {
    translation: translationRU,
  },
  uz: {
    translation: translationUZ,
  },
  en: {
    translation: translationEN,
  },
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  debug: false,
  fallbackLng: "uz",
  supportedLngs: ["uz", "ru", "en"],
  nonExplicitSupportedLngs: true,
  interpolation: {
    escapeValue: false,
  },
  resources,
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
});

export default i18n;
